var countryCode = ["60","63","66","81","84","852","855","86","880","91","93","95","961","963","965","968",
  "973","975","977","62","65","673","82","850","853","856","886","90","92","94","960","962",
  "964","966","972","974","976","98","7","31","33","350","352","354","356","358","336","338",
  "223","40","4175","44","46","48","30","32","34","351","353","355","357","359","49","39",
  "396","41","43","45","47","20","213","218","221","225","227","229","231","233","235",
  "237","239","240","242","244","247","249","251","253","255","257","260","262","264","266",
  "268","27","297","210","216","220","222","224","226","228","230","232","234","236","238",
  "241","243","245","248","250","252","254","256","258","261","263","265","267","269","290",
  "298","1","1808","1809","1907","299","500","502","504","506","509","52","54","56","58","592",
  "594","596","598","501","503","505","507","51","53","55","57","591","593","595","597",
  "61","671","6723","674","677","679","683","685","688","64","6722","6724","676","678","682",
  "684","686"];

//验证输入的电话区号是否存在
export const checkAreaCode = (value) => {
  var flag = false;
  //var userPhoneInter = $("#userPhoneInterInput").val();
  //if(userPhoneInter==value){
//	alert(countryCode.length);
  for (var i = 0; i < countryCode.length; i++) {
    if (countryCode[i].indexOf(value) > -1) {
      flag = true;
    }else{
      flag = false;
    }
    if(flag ){
      return true;
    }
  };
//	}
//else{
//		flag = false;
//	}
  return flag;
}

//验证输入的电话区号是否存在
export const checkAreaCodeFax = (value) => {
  var flag = false;
  //var userFaxInter = $("#userFaxInterInput").val();
  //if(userFaxInter==value){
  for (var i = 0; i < countryCode.length; i++) {
    if (countryCode[i].indexOf(value) > -1) {
      flag = true;
    }else{
      flag = false;
    }
    if(flag ){
      return true;
    }
  };
//	}else{
//		flag = false;
//	}
  return flag;
}
//判断是不是合法的Email的函数
export const IsEmail = (argValue) => {
  var emailStr=argValue.toLowerCase();
  var checkTLD=1;
//	var knownDomsPat=/^(com|net|org|edu|int|mil|gov|arpa|biz|aero|name|coop|info|pro|museum|mobi)$/;
  var specialChars="\\(\\)><@,;:\\\\\\\"\\.\\[\\]";
  var validChars="\[^\\s" + specialChars + "\]";
  var quotedUser="(\"[^\"]*\")";
  var ipDomainPat=/^\[(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})\]$/;
  var atom=validChars + '+';
  var word="(" + atom + "|" + quotedUser + ")";
  var userPat=new RegExp("^" + word + "(\\." + word + ")*$");
  var domainPat=new RegExp("^" + atom + "(\\." + atom +")*$");
  var emailPat=/^(.+)@(.+)$/;
  var matchArray=emailStr.match(emailPat);
  if (matchArray==null){
    return false;
  }
  var user=matchArray[1];
  var domain=matchArray[2];
  for (i=0; i<user.length; i++){
    if (user.charCodeAt(i)>127)
    {
      return false;
    }
  }
  for (i=0; i<domain.length; i++){
    if (domain.charCodeAt(i)>127){
      return false;
    }
  }
  if (user.match(userPat)==null){
    return false;
  }
  var IPArray=domain.match(ipDomainPat);
  if (IPArray!=null){
    for (var i=1;i<=4;i++)
    {
      if (IPArray[i]>255)
      {
        return false;
      }
    }
    return true;
  }
  var atomPat=new RegExp("^" + atom + "$");
  var domArr=domain.split(".");
  var len=domArr.length;
  for (i=0;i<len;i++){
    if (domArr[i].search(atomPat)==-1){
      return false;
    }
  }
  if (checkTLD && domArr[domArr.length-1].length < 2 ){
    return false;
  }
  if (len<2){
    return false;
  }
  return true;
}



// WEBPACK FOOTER //
// ./src/utils/areaCodeValidate.js